import { render, staticRenderFns } from "./iconForm.vue?vue&type=template&id=f1912d20&scoped=true&"
import script from "./iconForm.vue?vue&type=script&lang=js&"
export * from "./iconForm.vue?vue&type=script&lang=js&"
import style0 from "./iconForm.vue?vue&type=style&index=0&id=f1912d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1912d20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1912d20')) {
      api.createRecord('f1912d20', component.options)
    } else {
      api.reload('f1912d20', component.options)
    }
    module.hot.accept("./iconForm.vue?vue&type=template&id=f1912d20&scoped=true&", function () {
      api.rerender('f1912d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/businessCooperation/components/iconForm.vue"
export default component.exports